// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgramLogo__wrapper___a32Ez","icon":"ProgramLogo__icon___YT12n"};